module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/036-central-african-republic-53d2c06e0b0cba7809e5eef6c9ab833a.svg";